import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { LicensesPageService } from '../../services/licenses/licenses.page.service';

export interface ILicenseData {
  max: number;
  inUse: number;
}
@Component({
  selector: 'nrwl-monitor-license-status',
  templateUrl: './monitor-license-status.component.html',
  styleUrls: ['./monitor-license-status.component.scss']
})
export class MonitorLicenseStatusComponent implements OnInit, OnDestroy {
  @Output() availableLicenseCount: EventEmitter<number> = new EventEmitter();
  @Output() licenseDetail: EventEmitter<ILicenseData> = new EventEmitter();
  @Input() feature?: string;
  licenses = {
    max: 0,
    inUse: 0
  };

  private unsubscribe: Subject<void> = new Subject();

  constructor(private licensesPageService: LicensesPageService) {}

  ngOnInit() {
    this.updateLicenses();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getUsedMonitorsPercent(): number {
    return (this.licenses.inUse / this.licenses.max) * 100;
  }

  isLicenseExceeded(): boolean {
    return this.licenses.max > 0 && this.licenses.max <= this.licenses.inUse;
  }

  updateLicenses(): void {
    let licencseFeature = 'ACT-NUM-TESTS';
    if (this.feature && this.feature === 'agent') {
      licencseFeature = 'ACT-NUM-AGENTS';
    }
    this.licensesPageService
      .getLicenseCount()
      .pipe(take(1), takeUntil(this.unsubscribe))
      .subscribe(
        value => {
          if (value && value.length) {
            const monitorLicense = value.find(element => element.featureName === licencseFeature);
            if (monitorLicense) {
              this.licenses.max = monitorLicense.count || 0;
              this.licenses.inUse = monitorLicense.used || 0;
            }
            this.licenseDetail.emit(this.licenses);
            this.availableLicenseCount.emit(this.licenses.max - this.licenses.inUse);
          }
        },
        () => {}
      );
  }
}
